import * as React from "react";

import { Button, Modal } from "semantic-ui-react";

import { DisclaimerModal } from "./DisclaimerModal";
import { CaseMessaging } from "./CaseMessaging";

export interface MessagingModalProps {
    caseId: string;
    openModal: boolean;
    onCloseModal: () => void;
    customerId: string;
}

const MessagingModal: React.FC<MessagingModalProps> = (props: MessagingModalProps) => {

    const [openDisclaimer, setOpenDisclaimer] = React.useState<boolean>(true);

    const onConfirmDisclaimer = React.useCallback(() => {
        setOpenDisclaimer(false);
    },[]);

    const onCloseModal = React.useCallback(() => {
        props.onCloseModal();
    }, [props]);

    const cancelDisclaimer = React.useCallback(() => {
        setOpenDisclaimer(true);
        onCloseModal();
    }, [onCloseModal]);

    return (
        <>
            <Modal open={props.openModal}>
                <Modal.Header content="Case Messaging" />
                <Modal.Content>
                    <CaseMessaging customerId={props.customerId} caseId={props.caseId} onSubmit={onCloseModal} />
                </Modal.Content>
                <Modal.Actions>
                    <Button content="Exit" onClick={onCloseModal} />
                </Modal.Actions>
            </Modal>
            {
                openDisclaimer && props.openModal &&
                    <DisclaimerModal
                        openModal={openDisclaimer}
                        onConfirm={onConfirmDisclaimer}
                        onCancel={cancelDisclaimer} />
            }
        </>
    );
};

export {
    MessagingModal
};
